import { FC } from 'react';
import { match } from 'ts-pattern';

import { FormFieldProps } from '~/core/shared/components';
import {
  FormFieldControlledComponent,
  FormFieldUncontrolledComponent,
} from '~/core/shared/types';
import { CurrencyField, InputField, SelectField } from './fields';

export type FieldProps<F = Resources.FormField> = Omit<
  FormFieldProps<
    FormFieldControlledComponent | FormFieldUncontrolledComponent,
    { field: F }
  >,
  'component'
>;

type DocumentFieldProps = {
  field: Resources.FormField;
};

export const DocumentField = ({ field }: DocumentFieldProps) => {
  const isType = (type: string) => (f: Resources.FormField) =>
    f.fieldType === type || f.type === type;

  const fieldProps: FieldProps = {
    field,
    name: field.key,
    required: !!field.required,
    label: field.label,
  };

  const Field = match<Resources.FormField, FC<FieldProps>>(field)
    .when(isType('select'), () => SelectField)
    .when(isType('currency'), () => CurrencyField)
    // .when(isType('percent'), () => null)
    // .when(isType('date'), () => null)
    // .when(isType('longtext'), () => null)
    .otherwise(() => InputField);

  return <Field {...fieldProps} />;
};
